import { Button, Checkbox, Divider, Flex, Typography } from "antd";
import { useContext, useState } from "react";
import LoaderContext from "../../../../Context/LoaderContext/Index";
import { InterviewSession } from "../../../../Interface/Index";
import InstructionList from "./InstructionList";
import "./instruction.scss";

interface InstructionsProps {
  handleStart: () => void;
  session: InterviewSession | null;
}

const Instructions: React.FC<InstructionsProps> = ({
  handleStart,
  session,
}) => {
  const { isLoading } = useContext(LoaderContext);
  const [accepted, setAccepted] = useState(false);

  const handleAcceptClick = (e: any) => {
    setAccepted(e.target.checked);
  };

  let estimatedTime =
    session && session.noOfQuestionsGenerated
      ? session?.noOfQuestionsGenerated * 3
      : 0;

  return (
    <Flex vertical className="instruction_container">
      <Typography.Title level={3} style={{ textAlign: "center" }}>
        Important Instructions
      </Typography.Title>
      <Typography.Title
        level={5}
        style={{ textDecoration: "underline", textAlign: "center" }}
      >
        {estimatedTime > 0
          ? `Estimated time: ${estimatedTime} minutes`
          : "Questions are not generated yet."}
      </Typography.Title>

      <InstructionList />
      <Divider />
      <div style={{ textAlign: "center" }}>
        <Checkbox onChange={handleAcceptClick}>
          I read the instructions and understand the termination rules
        </Checkbox>
      </div>
      <div className="start_button_container">
        <Button
          type="primary"
          onClick={handleStart}
          loading={isLoading}
          disabled={!accepted || session?.status === "unqualified"}
          style={{ paddingInline: "100px" }}
        >
          Start
        </Button>
      </div>
    </Flex>
  );
};

export default Instructions;
